import { defineMessages } from '../../i18n/messages';

export const StatusMessages = defineMessages({
  PAGE_TITLE: {
    id: 'status.page_title',
    text: 'System Status',
    description: 'Page header on the system status page',
  },
  PAGE_SUBTITLE: {
    id: 'status.page_subtitle',
    text: 'Current operational status of Localingos services.',
    description: 'Subtitle below the page header on the status page',
  },
  ALL_OPERATIONAL: {
    id: 'status.all_operational',
    text: 'All Systems Operational ✅',
    description: 'Summary banner shown when all services are running normally',
  },
  SERVICES_HEADING: {
    id: 'status.services_heading',
    text: 'Services',
    description: 'Section heading above the list of individual service statuses',
  },
  REST_API: {
    id: 'status.rest_api',
    text: '✅ REST API: Operational',
    description: 'Status line item for the REST API service',
  },
  TRANSLATION_PIPELINE: {
    id: 'status.translation_pipeline',
    text: '✅ Translation Pipeline: Operational',
    description: 'Status line item for the translation pipeline service',
  },
  WEB_DASHBOARD: {
    id: 'status.web_dashboard',
    text: '✅ Web Dashboard: Operational',
    description: 'Status line item for the web dashboard service',
  },
  AUTHENTICATION: {
    id: 'status.authentication',
    text: '✅ Authentication (Cognito): Operational',
    description: 'Status line item for the Cognito authentication service',
  },
  BILLING: {
    id: 'status.billing',
    text: '✅ Billing (Stripe): Operational',
    description: 'Status line item for the Stripe billing service',
  },
  INCIDENTS_HEADING: {
    id: 'status.incidents_heading',
    text: 'Incidents',
    description: 'Section heading above the recent incidents list',
  },
  NO_INCIDENTS: {
    id: 'status.no_incidents',
    text: 'No recent incidents.',
    description: 'Placeholder text shown when there are no recent incidents',
  },
  REPORT_HEADING: {
    id: 'status.report_heading',
    text: 'Report an Issue',
    description: 'Section heading for the issue reporting area at the bottom of the status page',
  },
  REPORT_TEXT: {
    id: 'status.report_text',
    text: "If you're experiencing problems, please contact <1>support@localingos.com</1>.",
    description: 'Instruction text with a mailto link for reporting issues. <1> wraps the support email address',
  },
});
